<template>
  <div class="list-container">
    <div class="list-content">
      <ul>
        <li
          v-for="(item, index) in paginatedItems"
          :key="item.id"
          @click="handleItemClick(item.id)"
          :class="{
            hover: hoverIndex === index,
            active: activeIndex === index,
            'red-text': clickedIds.includes(item.id),
          }"
          @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = -1"
        >
          <div class="list-item-content">
            <span class="text">{{ item.text }}</span>
            <span class="time">{{ item.time }}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        v-if="totalPages > 1"
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="items.length"
        layout="prev, pager, next"
        :pager-count="7"
        style="background-color: #ededed"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ListComponent",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 4,
      hoverIndex: -1,
      activeIndex: -1,
      clickedIds: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.pageSize);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.items.slice(start, end);
    },
  },
  methods: {
    handleItemClick(id) {
      this.activeIndex = this.paginatedItems.findIndex(
        (item) => item.id === id
      );
      if (!this.clickedIds.includes(id)) {
        this.clickedIds.push(id);
      }
      const clickedItem = this.items.find((item) => item.id === id);
      if (clickedItem) {
        this.$emit("item-click", {
          id: clickedItem.id,
          text: clickedItem.text,
          time: clickedItem.time,
        });
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.activeIndex = -1;
    },
  },
};
</script>

<style scoped>
.list-container {
  display: flex;
  flex-direction: column;
  height: 90%; /* 确保父容器有高度 */
  min-height: 230px; /* 设置最小高度 */
  position: relative;
}

.list-content {
  flex: 1; /* 占据剩余空间 */
  overflow-y: auto; /* 内容过多时可滚动 */
}

.pagination-wrapper {
  padding: 0;
  text-align: center;
  /* border-top: 1px solid #f0f0f0; 可选的分隔线 */
  background: #ededed; /* 防止内容穿透 */
  position: sticky;
  bottom: 0;
}

.new-lists ul {
  list-style: none;
  padding: 0;
}
.new-lists li {
  padding: 6px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.new-lists li.hover {
  background-color: #f5f5f5;
}
.new-lists li.active {
  background-color: #e6f7ff;
}
.red-text .text {
  color: #f5222d;
}
.list-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time {
  color: #999;
  font-size: 12px;
}
.text {
  font-weight: 500;
  text-align: right;
  font-weight: 500;
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  /* min-width: 250px; */
}
</style>